
export const customerOptionValue = "custom-881";

export const isCustomOption = (value: string) => {
  return value?.includes?.("custom-");
}